export const UPDATE_DEALER_CREDENTIALS = 'UPDATE_DEALER_CREDENTIALS';
export const UPDATE_DEALER_CREDENTIALS_SUCCESSFUL = 'UPDATE_DEALER_CREDENTIALS_SUCCESSFUL';
export const UPDATE_DEALER_CREDENTIALS_FAILED = "UPDATE_DEALER_CREDENTIALS_FAILED";
export const RESET_ALERT = "RESET_ALERT";
export const BULK_UPDATE_DEALER_CREDENTIALS = 'BULK_UPDATE_DEALER_CREDENTIALS';
export const BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL = 'BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL';
export const BULK_UPDATE_DEALER_CREDENTIALS_FAILED = "BULK_UPDATE_DEALER_CREDENTIALS_FAILED";
export const PAGE_NUMBER = "PAGE_NUMBER";




